<script>
export default {
  watch: {
    selectedProducts: {
      handler(products) {
        if (products.length === 0) this.$store.dispatch('rfuset_selected', null);
      },
      deep: true,
    },
  },
  computed: {
    selectedProducts() {
      return this.$store.getters.getSelectedProductsRFU;
    },

    goodConditions() {
      if (typeof this.selectedProducts === 'undefined') return false;

      return this.selectedProducts.map((item) => {
        const good = item.filter((subItem) => subItem.condition === 0);

        return good.length === 0 ? good.length : good.reduce((sum, current) => (
          sum + Number(current.selected_quantity)
        ), 0);
      });
    },

    attentionConditions() {
      if (typeof this.selectedProducts === 'undefined') return false;

      return this.selectedProducts.map((item) => {
        const attention = item.filter((subItem) => subItem.condition === 2);

        return attention.length;
      });
    },

    badConditions() {
      if (typeof this.selectedProducts === 'undefined') return false;

      return this.selectedProducts.map((item) => {
        const bad = item.filter((subItem) => subItem.condition === 1);

        return bad.length;
      });
    },

    isButtonActive() {
      const isInvalid = this.selectedProducts
        .map((item) => item.filter((subItem) => subItem.valid === false).length === 0);

      const invalid = (element) => element === false;

      return isInvalid.some(invalid);
    },
  },
  methods: {
    utilize() {
      const prepareData = this.selectedProducts.reduce((sum, items) => {
        items.forEach((item) => {
          if (item.ids) {
            const ids = item.ids.slice(0, item.selected_quantity);
            sum.push(...ids);
          }
        });

        return sum;
      }, [])
        .map(Number);

      this.$store.commit('set_modal_inform', {
        type: 'inform',
        action: 'rfuutilize',
        action_data: prepareData,
        inform_message: 'Are you sure you want to utilize this products?',
      });
    },

    remove(subItem) {
      subItem.selected = false;
    },

    validate(product) {
      product.valid = (
        product.selected_quantity > 0 && product.selected_quantity <= product.quantity
      );
    },

    close(event) {
      if (typeof event === 'undefined') {
        this.$store.dispatch('rfuset_selected', null);
        return;
      }

      if (!event.target.closest('.modal-container') || event.target.classList.contains('close')) {
        this.$store.dispatch('rfuset_selected', null);
      }
    },
  },
};
</script>
<template src="./ready_utilize.pug" lang="pug"></template>
